module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-swiper"
  }, [_c('div', {
    staticClass: "sky-swiper-overflow-container"
  }, [_c('div', {
    staticClass: "sky-swiper-frame"
  }, [_c('ul', {
    staticClass: "sky-swiper-slides"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), _c('ul', {
    staticClass: "sky-swiper-bullets"
  }, _vm._l((_vm.slides), function(bullet, index) {
    return _c('li', [_c('button', {
      class: {
        active: index === _vm.currentSlide
      },
      on: {
        "click": function($event) {
          _vm.changeSlide(index)
        }
      }
    }, [_vm._v(" ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-68ddb7e8"}!./scripts/sky-swiper/sky-swiper.html
// module id = 356
// module chunks = 1